import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.048 2.048c-.683.684-.981 1.895-.981 4.174s.298 3.49.981 4.174c.684.684 1.895.982 4.174.982s3.49-.298 4.174-.982.982-1.894.982-4.174-.298-3.49-.982-4.174c-.684-.683-1.894-.981-4.174-.981s-3.49.298-4.174.981m-.754-.754C2.317.271 3.95 0 6.222 0s3.905.271 4.928 1.294 1.294 2.656 1.294 4.928-.27 3.905-1.294 4.928c-1.023 1.023-2.656 1.294-4.928 1.294s-3.905-.27-4.928-1.294C.271 10.128 0 8.494 0 6.222s.271-3.905 1.294-4.928m4.395 3.032c0-.295.239-.533.533-.533h.007a.533.533 0 1 1 0 1.066h-.007a.533.533 0 0 1-.533-.533m-.632 1.896c0-.294.239-.533.533-.533h.632c.295 0 .534.239.534.533v1.995h.098a.533.533 0 0 1 0 1.067h-.632a.533.533 0 0 1-.533-.533V6.756H5.59a.533.533 0 0 1-.533-.534",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }